module.exports = __webpack_public_path__ + "img/pix-old.4f906e2a.svg";